// extracted by mini-css-extract-plugin
export default {"modalWrap":"BaseModal_modalWrap__98X1V","modalInner":"BaseModal_modalInner__RIhvV"};